import { render, staticRenderFns } from "./KinvaItem.vue?vue&type=template&id=4bed94e6&scoped=true"
import script from "./KinvaItem.vue?vue&type=script&lang=js"
export * from "./KinvaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed94e6",
  null
  
)

export default component.exports